<template>
  <div>
    <el-button
        size="mini"
        type="primary"
        @click="handleAdd()"
        style="margin-bottom: 20px"
    >新增</el-button>

    <div v-loading="dataListLoading">
      <el-table  ref="tableForm" :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
        <el-table-column type="index" width="50" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="orgCode" header-align="center" align="center" label="公司代码" min-width="100">
        </el-table-column>
        <el-table-column prop="orgName" header-align="center" align="center" label="公司名称" min-width="250">
        </el-table-column>
        <el-table-column prop="werkCode" header-align="center" align="center" label="工厂代码" min-width="250">
        </el-table-column>
        <el-table-column prop="werkName" header-align="center" align="center" label="工厂名称" min-width="250">
        </el-table-column>
        <el-table-column prop="companyLogo" header-align="center" width="200" align="left" label="公司标识" min-width="250">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增对话框 -->
      <el-dialog title="新增箱标签打印设置" :visible.sync="addDialogVisible" width="600px" :close-on-click-modal="false">
        <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="120px">
          <el-form-item label="子公司：" prop="subcompany">
            <el-row>
              <el-col :span="20">
                <el-input
                    v-model="addForm.subcompany.name"
                    readonly
                    placeholder="请选择子公司"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="openSubcompanyDialog">搜索</el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="工厂：" prop="factory">
            <el-row>
              <el-col :span="20">
                <el-input
                    v-model="addForm.factory.name"
                    readonly
                    placeholder="请选择工厂"
                    :disabled="!addForm.subcompany.id"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-button
                    type="primary"
                    @click="openFactoryDialog"
                    :disabled="!addForm.subcompany.id"
                >搜索</el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="公司标识：" prop="companyLogo">
            <el-input v-model="addForm.companyLogo" placeholder="请输入公司标识"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">保 存</el-button>
      </span>
      </el-dialog>

      <!-- 子公司搜索帮助对话框 -->
      <el-dialog title="选择子公司" :visible.sync="subcompanyDialogVisible" width="800px">
        <el-input v-model="subcompanyFilter" placeholder="请输入子公司名称或代码" style="margin-bottom: 10px;"></el-input>
        <el-table
            :data="filteredSubcompanies"
            highlight-current-row
            @current-change="handleSubcompanySelect"
            height="300"
        >
          <el-table-column prop="orgCode" label="子公司代码" width="150"></el-table-column>
          <el-table-column prop="orgName" label="子公司名称"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="subcompanyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSubcompany">确 定</el-button>
      </span>
      </el-dialog>

      <!-- 工厂搜索帮助对话框 -->
      <el-dialog title="选择工厂" :visible.sync="factoryDialogVisible" width="800px">
        <el-input v-model="factoryFilter" placeholder="请输入工厂名称或代码" style="margin-bottom: 10px;"></el-input>
        <el-table
            :data="filteredFactories"
            highlight-current-row
            @current-change="handleFactorySelect"
            height="300"
        >
          <el-table-column prop="factoryCode" label="工厂代码" width="150"></el-table-column>
          <el-table-column prop="factoryName" label="工厂名称"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="factoryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFactory">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getSubcompanyBoxLabel, supCompanyList, getWerkBySubcode} from "../../../../controller/sys";
import {saveBoxLabelControl,deleteBoxLabelControl} from "../../../../controller/sap";

export default {
  name:'BoxLabelPrintingSettingIndex',
  data(){
    return{
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataList: [],
      // 新增对话框相关
      addDialogVisible: false,
      addForm: {
        subcompany: {
          id: '',
          code: '',
          name: ''
        },
        subcompanyId: '', // 专门存储子公司ID
        subcompanyCode: '', // 专门存储子公司代码
        factory: {
          id: '',
          code: '',
          name: ''
        },
        factoryId: '', // 专门存储工厂ID
        companyLogo: ''
      },
      addRules: {
        'subcompany.name': [{ required: true, message: '请选择子公司', trigger: 'change' }],
        'factory.name': [{ required: true, message: '请选择工厂', trigger: 'change' }],
        companyLogo: [{ required: true, message: '请输入公司标识', trigger: 'blur' }]
      },
      // 子公司搜索帮助相关
      subcompanyDialogVisible: false,
      subcompanyFilter: '',
      subcompanies: [], // 实际应从接口获取
      selectedSubcompany: null,
      // 工厂搜索帮助相关
      factoryDialogVisible: false,
      factoryFilter: '',
      factories: [], // 模拟数据，实际应从接口获取
      selectedFactory: null,
      rules: {
        companyLogo: [{
          required: true,
          validator: (rule, value, callback) => {
            const row = this.dataList.find(item => item.boxId === rule.boxId)
            if (row?.printFlag === '1' && !value) {
              callback(new Error('当选择打印时公司标识必填'))
            } else {
              callback()
            }
          }
        }]
      }
    }
  },
  activated() {
    this.getDataList()
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 410
      }
    },
    filteredSubcompanies() {
      if (!this.subcompanyFilter) {
        return this.subcompanies;
      }
      return this.subcompanies.filter(item =>
          item.orgCode.includes(this.subcompanyFilter) ||
          item.orgName.includes(this.subcompanyFilter)
      );
    },
    filteredFactories() {
      if (!this.factoryFilter) {
        return this.factories;
      }
      return this.factories.filter(item =>
          item.factoryCode.includes(this.factoryFilter) ||
          item.factoryName.includes(this.factoryFilter)
      );
    }
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      getSubcompanyBoxLabel({}).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.map(item => ({
            ...item,
            printFlag: item.printFlag || '0' // 默认值处理
          }))
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch((e) => {
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    handlePrintFlagChange(row) {
      // 切换时清空原有值
      if (row.printFlag === '0') {
        this.$set(row, 'companyLogo', '')
      }
    },
    handleSave() {
      const invalidItems = this.dataList.filter(item =>
          item.printFlag === '1' && !item.companyLogo
      )

      if (invalidItems.length > 0) {
        this.$message.error(` 以下公司要求打印但未填写标识：${
            invalidItems.map(i => i.orgName).join(' 、')
        }`)
      } else {
        saveBoxLabelControl({boxList: this.dataList}).then((res) => {
          if (res && res.code === '00') {
            this.getDataList()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        })
      }
    },
    // 新增按钮点击事件
    handleAdd() {
      // 初始化表单
      this.addForm = {
        subcompany: {
          id: '',
          code: '',
          name: ''
        },
        subcompanyId: '',
        subcompanyCode: '',
        factory: {
          id: '',
          code: '',
          name: ''
        },
        factoryId: '',
        companyLogo: ''
      };
      this.addDialogVisible = true;
    },
    // 加载子公司数据
    loadSubcompanies() {
      supCompanyList().then(response => {
        if (response && response.code === '00') {
          this.subcompanies = response.body.map(item => ({
            id: item.id,
            orgCode: item.orgCode,
            orgName: item.orgName
          }));
        }
      }).catch(error => {
        this.$message.error('加载子公司数据失败');
        console.error(error);
      });
    },
    // 加载工厂数据
    loadFactories() {
      // 根据子公司代码获取对应的工厂信息
      console.log('addform.subcompanyCode',this.addForm.subcompanyCode)
      getWerkBySubcode({},this.addForm.subcompanyCode).then(response => {
        if (response && response.code === '00') {
          this.factories = response.body.map(item => ({
            id: item.id,
            factoryCode: item.orgCode,
            factoryName: item.orgName,
          }));
        }
      }).catch(error => {
        this.$message.error('加载工厂数据失败');
        console.error(error);
      });
    },
    // 打开子公司搜索帮助
    openSubcompanyDialog() {
      this.subcompanyDialogVisible = true;
      this.selectedSubcompany = null;
      // 加载子公司数据
      this.loadSubcompanies();
    },
    // 打开工厂搜索帮助
    openFactoryDialog() {
      console.log('addform',this.addForm)
      if (!this.addForm.subcompany.id) {
        this.$message.warning('请先选择子公司');
        return;
      }
      this.factoryDialogVisible = true;
      this.selectedFactory = null;
      this.loadFactories();
    },
    // 选择子公司
    handleSubcompanySelect(row) {
      this.selectedSubcompany = row;
    },
    // 选择工厂
    handleFactorySelect(row) {
      this.selectedFactory = row;
    },
    // 确认子公司选择
    confirmSubcompany() {
      if (!this.selectedSubcompany) {
        this.$message.warning('请选择子公司');
        return;
      }

      this.addForm.subcompany = {
        id: this.selectedSubcompany.id,
        code: this.selectedSubcompany.orgCode,
        name: this.selectedSubcompany.orgName
      };

      // 保存subcompany id和orgCode用于后续操作
      this.addForm.subcompanyId = this.selectedSubcompany.id;
      this.addForm.subcompanyCode = this.selectedSubcompany.orgCode;

      // 清空之前选择的工厂
      this.addForm.factory = {
        id: '',
        code: '',
        name: ''
      };
      this.addForm.factoryId = '';
      // // 根据子公司代码加载对应的工厂列表
      // this.loadFactories(this.selectedSubcompany.orgCode);
      this.subcompanyDialogVisible = false;
    },
    // 确认工厂选择
    confirmFactory() {
      if (!this.selectedFactory) {
        this.$message.warning('请选择工厂');
        return;
      }

      this.addForm.factory = {
        id: this.selectedFactory.id,
        code: this.selectedFactory.factoryCode,
        name: this.selectedFactory.factoryName
      };

      // 保存工厂ID
      this.addForm.factoryId = this.selectedFactory.id;

      this.factoryDialogVisible = false;
    },
    // 保存新增
    saveAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 额外验证子公司和工厂是否已选择
          if (!this.addForm.subcompany.id) {
            this.$message.warning('请选择子公司');
            return;
          }

          if (!this.addForm.factory.id) {
            this.$message.warning('请选择工厂');
            return;
          }

          // 这里执行保存逻辑
          // 添加到列表，包含所有必要的信息
          const newItem = {
            printFlag: '1', // 默认打印
            companyLogo: this.addForm.companyLogo,
            // 保存额外信息用于最终提交
            subcompanyId: this.addForm.subcompany.id,
            werks: this.addForm.factory.code
          };

          this.dataList.push(newItem);
          this.addDialogVisible = false;
          this.handleSave();
        } else {
          this.$message.warning('请完善必填信息');
        }
      });
    },
    // 删除行
    handleDelete(row) {
      this.$confirm('确认删除该条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBoxLabelControl( {boxId: row.boxId}).then((res) => {
          if (res && res.code === '00') {
            this.getDataList()
            this.$message.success('删除成功')
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        // 用户取消删除
      });
    }
  }
}
</script>

<style lang="scss">
.required-print.el-input-inner {
  border-left: 3px solid #f56c6c
}
</style>
